const buildingTypes = {
  GET_ALL_BUILDINGS_SUCCESS: 'GET_ALL_BUILDINGS_SUCCESS',
  GET_ALL_BUILDINGS_FAILURE: 'GET_ALL_BUILDINGS_FAILURE',
  BUILDING_LOADING: 'BUILDING_LOADING',
  BUILDING_LOADING_SUCCESS: 'BUILDING_LOADING_SUCCESS',
  BUILDING_LOADING_FAIL: 'BUILDING_LOADING_FAIL'
};

export default buildingTypes;
